import { IAuthPostDto } from 'shared/interfaces';
import BaseApiService from './BaseApiService';

class AuthApiService extends BaseApiService {
    constructor() {
        super('');
    }

    login(authData: IAuthPostDto): Promise<{
        token: string;
        language?: string;
    }> {
        return this.POST('login', authData);
    }

    register(authData: any): Promise<any> {
        return this.POST('register', authData);
    }

    registerSecondary(authData: {
        username: string;
        password: string;
        email?: string;
    }): Promise<any> {
        return this.POST('register_a', authData);
    }
}

export default new AuthApiService();
